"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { useWaveById } from "@/hooks/useWaveById";
import { DropAuthorBadges } from "@/components/waves/drops/DropAuthorBadges";
interface ProfileCurationBadgeProps {
  readonly profile: ApiIdentity;
}
const getTrimmedText = (value?: string | null): string | null => {
  const trimmed = value?.trim();
  if (!trimmed) {
    return null;
  }
  return trimmed;
};
export default function ProfileCurationBadge(t0) {
  const $ = _c(9);
  const {
    profile
  } = t0;
  let t1;
  if ($[0] !== profile.profile_wave_id) {
    t1 = getTrimmedText(profile.profile_wave_id);
    $[0] = profile.profile_wave_id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const profileWaveId = t1;
  const t2 = Boolean(profileWaveId);
  let t3;
  if ($[2] !== t2) {
    t3 = {
      enabled: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    wave
  } = useWaveById(profileWaveId, t3);
  const hasConfirmedWave = wave?.id === profileWaveId;
  const t4 = hasConfirmedWave ? profileWaveId : null;
  const t5 = hasConfirmedWave ? wave.name : null;
  const t6 = hasConfirmedWave ? wave.picture : null;
  let t7;
  if ($[4] !== profile || $[5] !== t4 || $[6] !== t5 || $[7] !== t6) {
    const profileWithWave = {
      ...profile,
      profile_wave_id: t4,
      profile_wave_name: t5,
      profile_wave_pfp: t6
    };
    t7 = <DropAuthorBadges profile={profileWithWave} tooltipIdPrefix="profile-author-badges" />;
    $[4] = profile;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
}